import { MutationTree } from "vuex";
import { TemplateItem, TemplatesState } from "./types";
import {isEqual} from "lodash";

export const mutations: MutationTree<TemplatesState> = {
  pushToStateTemplates: (state, data) => {
    state.templates = state.templates.concat(data);
  },

  setTemplates: (state, data) => {
    state.templates = data;
  },

  setMultichannelTemplates: (state, data) => {
    state.multichannelTemplates = data;
  },

  setTemplateItem: (state, data) => {
    state.templateItem = data;
  },

  addTemplates(state, templates: TemplateItem[]) {
    const templateState = state.allTemplates;
    templates.forEach((template: TemplateItem) => {
      let activeObject = templateState.find((item) => item.id === template.id);
      let activeIndex = templateState.findIndex((item) => item.id === template.id);
      if (activeObject) {
        if (!isEqual(template, activeObject)) {
          state.allTemplates.splice(activeIndex, 1, template);
        }
      } else {
        state.allTemplates.push(template);
      }
    });
  },
};
